"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PrivacyNoticeSections;
const react_1 = __importDefault(require("react"));
function PrivacyNoticeSections({ sections }) {
    return react_1.default.createElement(react_1.default.Fragment, null, sections.map(section => react_1.default.createElement("section", { className: "mb-4", key: section.heading },
        react_1.default.createElement("h2", { className: "h6" }, section.heading),
        react_1.default.createElement("p", { style: { whiteSpace: "pre-line" } }, section.text))));
}
